export default {
  install(Vue) {
    Vue.filter("numberToFixed", function (v, precision = 2, padEnd = "1") {
      if (dsf.isUnDef(v) || v == "") {
        return "";
      }
      // 转换为字符串并处理
      const numStr = v.toString().trim();
      if (!/^\d+(\.\d+)?$/.test(numStr)) {
        return "";
      }
      return dsf.format("toFixed", v, [precision, padEnd]);
    });
  },
};
